module.exports = "<div class=\"damage-level-wrapper\" #damageLevelScreen>\n\t<div class=\"barChart\" *ngFor=\"let value of values; let i = index;\" [ngStyle]=\"{'width': barWidth + 'px', 'background-image': gradients[i]}\" [ngClass]=\"{active: value ===selectValue}\" (click)=\"selectChart(value)\">\n\t\t<div class=\"text\">{{value}}</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/level-slider/level-slider.component.html
// module id = ../../../../../src/app/utilities/level-slider/level-slider.component.html
// module chunks = main